import React from 'react'
import {
  IconButton,
  AppBar,
  Toolbar,
  createStyles,
  withStyles,
} from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'

const styles = () => {
  const backgroundColor = 'white'
  return createStyles({
    appBar: {
      backgroundColor,
      boxShadow: 'none',
    },
    toolbar: {
      backgroundColor,
    },
    button: {
      marginLeft: 'auto',
    },
  })
}

const Nav = ({ classes, hideMenu }) => {
  return (
    <AppBar className={classes.appBar} position="sticky">
      <Toolbar className={classes.toolbar}>
        <IconButton
          className={classes.button}
          onClick={hideMenu}
          aria-label="Hide menu"
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  )
}

export default withStyles(styles)(Nav)
